import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=8841865a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8841865a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8841865a')) {
      api.createRecord('8841865a', component.options)
    } else {
      api.reload('8841865a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=8841865a&scoped=true&", function () {
      api.rerender('8841865a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8bYpL9Coyj52H/JS/comp/Accordion.vue"
export default component.exports